import { render } from "./App.vue?vue&type=template&id=a51e1fbe&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=a51e1fbe&lang=less&scoped=true"

import exportComponent from "/Users/chengyanbin/Codes/Daming/ksdm_offline/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a51e1fbe"]])

export default __exports__